import React from 'react'
import { connect } from 'react-redux'
import { getUsers, deleteUser, getCustomers, getPermissions, sendEditUser, resetUserPassword, getTeams, getFolders, getDatabases, getCurrentUser } from '../../actions/userActions'
import { applyFilter, showPopup, showProgress, showMessage } from '../../actions/uiActions'
import { bindActionCreators } from 'redux'
import Admin from '../../components/users/Admin'


class AdminContainer extends React.Component {

    componentDidMount() {
        if (this.props.userList.length === 0 && !this.props.userCheck) {
            this.props.getUsers()

            if (this.props.role === "IEAdmin" || this.props.role === "ClientAdmin") {
                this.props.getDatabases()
            }

            if (this.props.role === "IEAdmin" || this.props.role === "ClientAdmin" || this.props.role === "Builder") {
                this.props.getCustomers()
                this.props.getPermissions()
                this.props.getTeams()
                this.props.getFolders()
            }
        }

        if (this.props.currentUser === null) {
            this.props.getCurrentUser(this.props.userID);
        }
    }
    
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.currentUser === null) {
            this.props.getCurrentUser(this.props.userID);
        }

        if (this.props.userList.length !== nextProps.userList.length || (this.props.userFilter !== nextProps.userFilter)) {
            return true
            
        } else {
            return false
        }
    }
    
    render() {
        return (
            <Admin
                rolesList={this.props.rolesList}
                userList={this.props.userList}
                deleteUser={this.props.deleteUser}
                showPopup={this.props.showPopup}
                customerList={this.props.customerList}
                folderList={this.props.folderList}
                databaseList={this.props.databaseList}
                permissionsList={this.props.permissionsList}
                sendEditUser={this.props.sendEditUser}
                resetUserPassword={this.props.resetUserPassword}
                userFilter={this.props.userFilter}
                showProgress={this.props.showProgress}
                showMessage={this.props.showMessage}
                role={this.props.role}
                applyFilter={this.props.applyFilter}
                currentUser={this.props.currentUser}
                userID={this.props.userID}
                getCurrentUser={this.props.getCurrentUser}
            />
        )
    }

}

function mapStateToProps(state) {
    return {
        role: state.users.role,
        userList: state.users.data,
        folderList: state.users.folderList,
        databaseList: state.users.databaseList,
        rolesList: state.users.data2,
        customerList: state.users.customerList,
        userCheck: state.users.userCheck,
        userFilter: state.users.userFilter,
        permissionsList: state.users.permissionsList,
        currentUser: state.users.currentUser,
        userID: state.users.userID
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ applyFilter, getUsers, deleteUser, getCustomers, getPermissions, sendEditUser, resetUserPassword, showPopup, showProgress, showMessage, getTeams, getFolders, getDatabases, getCurrentUser }, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AdminContainer)